import React from "react";
import { graphql } from "gatsby";

import { convertToUrlPath, getShortValueFromDictionary } from "../helpers";

import Layout from "../components/layout";

import Header from "../components/organisms/header";
import Footer from "../components/organisms/footer";
import Section from "../components/organisms/section";

import HeaderBrand from "../components/molecules/header-brand";
import FooterBrand from "../components/molecules/footer-brand";
import FooterNav from "../components/molecules/footer-nav";
import FooterCopy from "../components/molecules/footer-copy";
import NavBar from "../components/molecules/navbar";
import ImageButton from "../components/molecules/image-button";
import HeaderTitle from "../components/molecules/header-title";
import Card from "../components/molecules/card";

import Seo from "../components/atoms/seo";

class Articles extends React.Component {
  render() {
    const dictionaryEdges = this.props.data.allContentfulDictionaryEntry.edges;

    const allArticles = this.props.data.allContentfulArticle.edges;
    const renderedArticles = allArticles.map((article, index) => {
      return (
        <div
          className={index === 0 ? "col-md-12 mb-6" : "col-md-6"}
          key={index}
        >
          <Card
            title={article.node.title}
            description={article.node.introduction.introduction}
            media={
              index <= 4 && article.node.media
                ? {
                  fluid:
                      index === 0
                        ? article.node.media.bigImage
                        : article.node.media.fluid,
                  extension: article.node.media.file.url
                    .split(".")
                    .slice(-1)[0],
                  src: article.node.media.file.url,
                  alt: article.node.media.title,
                }
                : undefined
            }
            to={
              "/articles/" +
              (article.node.slug && article.node.slug.length
                ? article.node.slug
                : convertToUrlPath(article.node.title))
            }
          />
        </div>
      );
    });

    return (
      <Layout location={this.props.location}>
        <Seo
          title={getShortValueFromDictionary(
            dictionaryEdges,
            "articles.seo-title",
            this.props.pageContext.language
          )}
          description={getShortValueFromDictionary(
            dictionaryEdges,
            "articles.seo-description",
            this.props.pageContext.language
          )}
        />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <Section className="pt-5 pb-5">
          <HeaderTitle
            title={getShortValueFromDictionary(
              dictionaryEdges,
              "articles.header-title",
              this.props.pageContext.language
            )}
          />
          <div className="row">{renderedArticles}</div>
        </Section>
        <Section className="section-grey-split pt-5 pb-0 pb-sm-5">
          <div className="row">
            <div className="col-sm-10 ml-auto">
              <ImageButton
                to="solutions"
                fluid={this.props.data.whatwecandoImage.childImageSharp.fluid}
                alt={getShortValueFromDictionary(
                  dictionaryEdges,
                  "articles.solutions-teaser.image-alt",
                  this.props.pageContext.language
                )}
                title={getShortValueFromDictionary(
                  dictionaryEdges,
                  "articles.solutions-teaser.cta",
                  this.props.pageContext.language
                )}
              />
            </div>
          </div>
        </Section>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    whatwecandoImage: file(
      relativePath: {
        eq: "background/thomas-drouault-IBUcu_9vXJc-unsplash_cropped.jpg"
      }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 800) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allContentfulArticle(
      sort: { fields: [publishedAt], order: DESC }
      filter: { node_locale: { eq: "en-EU" } }
    ) {
      edges {
        node {
          title
          slug
          introduction {
            introduction
          }
          media {
            title
            fluid(maxWidth: 800, quality: 100) {
              aspectRatio
              src
              srcSet
              sizes
            }
            bigImage: fluid(maxWidth: 1800) {
              aspectRatio
              src
              srcSet
              sizes
            }
            file {
              url
            }
          }
        }
      }
    }
    allContentfulDictionaryEntry(filter: { key: { regex: "/articles/i" } }) {
      edges {
        node {
          key
          shortValue
          richValue {
            raw
          }
          node_locale
        }
      }
    }
  }
`;

export default Articles;
